import React from "react";

const SmartCampaignPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy for Smart Campaign
      </h1>

      <p className="mb-4">
        <strong>Effective Date:</strong> 16-01-2025
      </p>

      <p className="mb-6">
        At Smart Campaign (“we,” “our,” or “us”), we prioritize your privacy and
        are committed to safeguarding the information you share with us. This
        Privacy Policy outlines how we collect, use, and protect your data when
        using our Shopify app. By installing and using our app, you agree to the
        practices described below.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        1. Information We Collect
      </h2>

      <h3 className="text-xl font-medium mb-2">a. Shopify Data</h3>
      <p className="mb-2">
        When you install our app, we access certain data from your Shopify
        account, including:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Store name, domain, and owner email address.</li>
        <li>
          Products and collections required for campaign setup and management.
        </li>
        <li>Discounts, tags, and related sales campaign data.</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">b. App Usage Data</h3>
      <p className="mb-2">
        We collect information about how you interact with the app, such as:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          Campaign configurations, schedules, and discount details.
        </li>
        <li>
          Actions performed within the app, including scheduling and applying
          discounts.
        </li>
      </ul>

      <h3 className="text-xl font-medium mb-2">c. Technical Data</h3>
      <p className="mb-2">
        To enhance the app experience, we may collect technical details such as:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Browser type and version.</li>
        <li>IP address and device identifiers.</li>
        <li>Shopify API interactions.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          Enable the app’s core functionality, such as campaign scheduling and
          discount application.
        </li>
        <li>
          Provide customer support and address technical issues.
        </li>
        <li>
          Improve app performance and develop new features.
        </li>
        <li>
          Analyze app usage trends to enhance user experience.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        3. Sharing Your Information
      </h2>
      <p className="mb-2">
        We do not sell or trade your personal information. However, we may share
        data with trusted third parties for:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>App Functionality:</strong> Interacting with Shopify APIs to
          execute campaigns.
        </li>
        <li>
          <strong>Service Providers:</strong> Hosting, analytics, and technical
          support services.
        </li>
        <li>
          <strong>Legal Compliance:</strong> When required to comply with laws or
          enforce our terms.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        4. Data Retention
      </h2>
      <p className="mb-6">
        We retain your data only as long as necessary to provide app services or
        comply with legal obligations. If you uninstall the app, we will delete
        your data unless it is required for legal purposes.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        5. Data Security
      </h2>
      <p className="mb-6">
        We use advanced security measures to protect your information. However,
        no system is entirely secure, and we cannot guarantee absolute
        protection.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        6. Your Rights
      </h2>
      <p className="mb-2">
        Depending on your location, you may have the following rights:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access and review the data we store about you.</li>
        <li>Request corrections or deletions of your data.</li>
        <li>Restrict or object to data processing.</li>
      </ul>
      <p className="mb-6">
        To exercise these rights, contact us at{" "}
        <a
          href="mailto:support@mean3.com"
          className="text-blue-500 hover:underline"
        >
          support@mean3.com
        </a>
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        7. Changes to This Policy
      </h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page with an updated "Effective Date."
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        8. Contact Us
      </h2>
      <p className="mb-2">
        If you have questions or concerns about this Privacy Policy, please
        contact us:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:support@mean3.com"
            className="text-blue-500 hover:underline"
          >
            support@mean3.com
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SmartCampaignPrivacyPolicy;